"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformTokenResponseCamelCase = exports.transformTokenRequestSnakeCase = exports.transformResponseCamelCase = exports.transformRequestSnakeCase = exports.transformReactorResponseCamelCase = exports.transformReactorRequestSnakeCase = exports.transformProxyResponseCamelCase = exports.transformProxyRequestSnakeCase = exports.proxyRaw = exports.getRuntime = exports.getQueryParams = exports.getOSVersion = exports.getBrowser = exports.errorInterceptorDebug = exports.errorInterceptor = exports.debugTransform = exports.dataExtractor = exports.dataAndHeadersExtractor = exports.createRequestConfig = exports.concatResponseTransformerWithDefault = exports.concatRequestTransformerWithDefault = exports.buildUserAgentString = exports.buildClientUserAgentString = exports.assertInit = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _camelcaseKeys = _interopRequireDefault(require("camelcase-keys"));

var _os = _interopRequireDefault(require("os"));

var _snakeCase = require("snake-case");

var _snakecaseKeys = _interopRequireDefault(require("snakecase-keys"));

var _BasisTheoryApiError = require("./BasisTheoryApiError");

var _constants = require("./constants");

var _logging = require("./logging");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const assertInit = prop => {
  if (prop === null || prop === undefined) {
    throw new Error('BasisTheory has not yet been properly initialized.');
  }

  return prop;
};

exports.assertInit = assertInit;

const transformRequestSnakeCase = data => {
  if (typeof data === 'undefined') {
    return undefined;
  }

  return (0, _snakecaseKeys.default)(data, {
    deep: true
  });
};

exports.transformRequestSnakeCase = transformRequestSnakeCase;

const proxyRaw = data => data;

exports.proxyRaw = proxyRaw;

const transformReactorRequestSnakeCase = reactor => {
  if (typeof reactor === 'undefined') {
    return undefined;
  }

  return { ...(0, _snakecaseKeys.default)(reactor, {
      deep: true
    }),
    ...(reactor.configuration !== undefined ? {
      configuration: reactor.configuration
    } : {})
  };
};

exports.transformReactorRequestSnakeCase = transformReactorRequestSnakeCase;

const transformProxyRequestSnakeCase = proxy => {
  if (typeof proxy === 'undefined') {
    return undefined;
  }

  return { ...(0, _snakecaseKeys.default)(proxy, {
      deep: true
    }),
    ...(proxy.configuration !== undefined ? {
      configuration: proxy.configuration
    } : {})
  };
};

exports.transformProxyRequestSnakeCase = transformProxyRequestSnakeCase;

const transformTokenRequestSnakeCase = payload => {
  if (typeof payload === 'undefined') {
    return undefined;
  }

  return { ...(0, _snakecaseKeys.default)(payload, {
      deep: true
    }),
    ...(payload.data !== undefined ? {
      data: payload.data
    } : {}),
    ...(payload.metadata !== undefined ? {
      metadata: payload.metadata
    } : {})
  };
};

exports.transformTokenRequestSnakeCase = transformTokenRequestSnakeCase;

const isList = arg => arg && (arg === null || arg === void 0 ? void 0 : arg.pagination) !== undefined && (arg === null || arg === void 0 ? void 0 : arg.data) !== undefined;

const transformTokenResponseCamelCase = tokenResponse => {
  if (typeof tokenResponse === 'undefined') {
    return undefined;
  }

  if (isList(tokenResponse)) {
    const transformedData = tokenResponse.data.map(t => ({ ...(0, _camelcaseKeys.default)(t, {
        deep: true
      }),
      ...(t.data !== undefined ? {
        data: t.data
      } : {}),
      ...(t.metadata !== undefined ? {
        metadata: t.metadata
      } : {})
    }));
    const transformedToken = {
      data: transformedData,
      pagination: (0, _camelcaseKeys.default)(tokenResponse.pagination, {
        deep: true
      })
    };
    return transformedToken;
  }

  return { ...(0, _camelcaseKeys.default)(tokenResponse, {
      deep: true
    }),
    ...(tokenResponse.data !== undefined ? {
      data: tokenResponse.data
    } : {}),
    ...(tokenResponse.metadata !== undefined ? {
      metadata: tokenResponse.metadata
    } : {})
  };
};

exports.transformTokenResponseCamelCase = transformTokenResponseCamelCase;

const transformReactorResponseCamelCase = reactorResponse => {
  if (typeof reactorResponse === 'undefined') {
    return undefined;
  }

  if (isList(reactorResponse)) {
    const transformedData = reactorResponse.data.map(r => ({ ...(0, _camelcaseKeys.default)(r, {
        deep: true
      }),
      ...(r.configuration !== undefined ? {
        configuration: r.configuration
      } : {})
    }));
    const transformedReactor = {
      data: transformedData,
      pagination: (0, _camelcaseKeys.default)(reactorResponse.pagination, {
        deep: true
      })
    };
    return transformedReactor;
  }

  return { ...(0, _camelcaseKeys.default)(reactorResponse, {
      deep: true
    }),
    ...(reactorResponse.configuration !== undefined ? {
      configuration: reactorResponse.configuration
    } : {})
  };
};

exports.transformReactorResponseCamelCase = transformReactorResponseCamelCase;

const transformProxyResponseCamelCase = proxyResponse => {
  if (typeof proxyResponse === 'undefined') {
    return undefined;
  }

  if (isList(proxyResponse)) {
    const transformedData = proxyResponse.data.map(p => ({ ...(0, _camelcaseKeys.default)(p, {
        deep: true
      }),
      ...(p.configuration !== undefined ? {
        configuration: p.configuration
      } : {})
    }));
    const transformedReactor = {
      data: transformedData,
      pagination: (0, _camelcaseKeys.default)(proxyResponse.pagination, {
        deep: true
      })
    };
    return transformedReactor;
  }

  return { ...(0, _camelcaseKeys.default)(proxyResponse, {
      deep: true
    }),
    ...(proxyResponse.configuration !== undefined ? {
      configuration: proxyResponse.configuration
    } : {})
  };
};

exports.transformProxyResponseCamelCase = transformProxyResponseCamelCase;

const transformResponseCamelCase = data => {
  if (typeof data === 'undefined') {
    return undefined;
  }

  return (0, _camelcaseKeys.default)(data, {
    deep: true
  });
};

exports.transformResponseCamelCase = transformResponseCamelCase;

const dataExtractor = res => res === null || res === void 0 ? void 0 : res.data;

exports.dataExtractor = dataExtractor;

const dataAndHeadersExtractor = res => ({
  data: res === null || res === void 0 ? void 0 : res.data,
  headers: res === null || res === void 0 ? void 0 : res.headers
});

exports.dataAndHeadersExtractor = dataAndHeadersExtractor;

const concatRequestTransformerWithDefault = requestTransformer => [...[], ...[requestTransformer], ..._axios.default.defaults.transformRequest];

exports.concatRequestTransformerWithDefault = concatRequestTransformerWithDefault;

const concatResponseTransformerWithDefault = responseTransformer => [..._axios.default.defaults.transformResponse, ...[responseTransformer]];

exports.concatResponseTransformerWithDefault = concatResponseTransformerWithDefault;

const createRequestConfig = (options, transformers) => {
  if (!options) {
    if (!transformers) {
      return undefined;
    }

    return { ...(transformers.transformRequest !== undefined ? {
        transformRequest: concatRequestTransformerWithDefault(transformers.transformRequest)
      } : {}),
      ...(transformers.transformResponse !== undefined ? {
        transformResponse: concatResponseTransformerWithDefault(transformers.transformResponse)
      } : {})
    };
  }

  const {
    apiKey,
    correlationId,
    idempotencyKey,
    query,
    headers
  } = options;
  const apiKeyHeader = apiKey ? {
    [_constants.API_KEY_HEADER]: apiKey
  } : {};
  const correlationIdHeader = correlationId ? {
    [_constants.BT_TRACE_ID_HEADER]: correlationId
  } : {};
  const idempotencyKeyHeader = idempotencyKey ? {
    [_constants.BT_IDEMPOTENCY_KEY_HEADER]: idempotencyKey
  } : {};
  return {
    headers: { ...apiKeyHeader,
      ...correlationIdHeader,
      ...idempotencyKeyHeader,
      ...(typeof headers !== 'undefined' && { ...headers
      })
    },
    ...(typeof query !== 'undefined' && {
      params: query
    }),
    ...((transformers === null || transformers === void 0 ? void 0 : transformers.transformRequest) !== undefined ? {
      transformRequest: concatRequestTransformerWithDefault(transformers.transformRequest)
    } : {}),
    ...((transformers === null || transformers === void 0 ? void 0 : transformers.transformResponse) !== undefined ? {
      transformResponse: concatResponseTransformerWithDefault(transformers.transformResponse)
    } : {})
  };
};

exports.createRequestConfig = createRequestConfig;

const handleAxiosError = (error, debug) => {
  var _error$response$statu, _error$response, _error$response2, _error$config, _error$config$method, _error$config2, _error$config3, _error$config4, _error$config4$method, _error$config5, _error$config5$header, _error$response5, _error$response6, _error$response7, _error$response8;

  const status = (_error$response$statu = error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) !== null && _error$response$statu !== void 0 ? _error$response$statu : -1;
  const data = error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data;

  let _debug;

  if (debug) {
    var _error$response3, _error$response3$head, _error$response4, _error$response4$head;

    _debug = {
      cfRay: error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : (_error$response3$head = _error$response3.headers) === null || _error$response3$head === void 0 ? void 0 : _error$response3$head[_constants.CF_RAY_HEADER],
      btTraceId: error === null || error === void 0 ? void 0 : (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : (_error$response4$head = _error$response4.headers) === null || _error$response4$head === void 0 ? void 0 : _error$response4$head[_constants.BT_TRACE_ID_HEADER]
    };
  }

  const logSeverity = status > -1 && status < 499 ? 'warn' : 'error';

  _logging.logger.log[logSeverity](`Error when making ${error === null || error === void 0 ? void 0 : (_error$config = error.config) === null || _error$config === void 0 ? void 0 : (_error$config$method = _error$config.method) === null || _error$config$method === void 0 ? void 0 : _error$config$method.toUpperCase()} request to ${error === null || error === void 0 ? void 0 : (_error$config2 = error.config) === null || _error$config2 === void 0 ? void 0 : _error$config2.baseURL} from the JS SDK`, {
    apiStatus: status,
    logType: 'axiosError',
    logOrigin: 'axiosErrorInterceptor',
    requestDetails: {
      url: error === null || error === void 0 ? void 0 : (_error$config3 = error.config) === null || _error$config3 === void 0 ? void 0 : _error$config3.baseURL,
      method: error === null || error === void 0 ? void 0 : (_error$config4 = error.config) === null || _error$config4 === void 0 ? void 0 : (_error$config4$method = _error$config4.method) === null || _error$config4$method === void 0 ? void 0 : _error$config4$method.toUpperCase(),
      btUserAgent: error === null || error === void 0 ? void 0 : (_error$config5 = error.config) === null || _error$config5 === void 0 ? void 0 : (_error$config5$header = _error$config5.headers) === null || _error$config5$header === void 0 ? void 0 : _error$config5$header[_constants.CLIENT_USER_AGENT_HEADER]
    },
    errorDetails: {
      code: error === null || error === void 0 ? void 0 : error.code,
      name: error === null || error === void 0 ? void 0 : error.name,
      stack: error === null || error === void 0 ? void 0 : error.stack,
      headers: error === null || error === void 0 ? void 0 : (_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : _error$response5.headers,
      message: error === null || error === void 0 ? void 0 : error.message,
      status: error === null || error === void 0 ? void 0 : (_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : _error$response6.status,
      statusText: error === null || error === void 0 ? void 0 : (_error$response7 = error.response) === null || _error$response7 === void 0 ? void 0 : _error$response7.statusText,
      data: error === null || error === void 0 ? void 0 : (_error$response8 = error.response) === null || _error$response8 === void 0 ? void 0 : _error$response8.data
    }
  });

  throw new _BasisTheoryApiError.BasisTheoryApiError(error.message, status, data, _debug);
};

const errorInterceptor = error => handleAxiosError(error, false);

exports.errorInterceptor = errorInterceptor;

const errorInterceptorDebug = error => handleAxiosError(error, true);

exports.errorInterceptorDebug = errorInterceptorDebug;

const getQueryParams = (query = {}) => {
  const keys = Object.keys(query);

  if (keys.length) {
    const params = new URLSearchParams();

    const appendSafe = (key, value, isNested = false) => {
      const type = typeof value;
      const formattedKey = isNested ? key : (0, _snakeCase.snakeCase)(key);

      if (value === null || ['boolean', 'number', 'string'].includes(type)) {
        params.append(formattedKey, value);
      }
    };

    keys.forEach(key => {
      const value = query[key];

      if (Array.isArray(value)) {
        value.forEach(aValue => {
          appendSafe(String(key), aValue);
        });
      } else if (value && typeof value === 'object') {
        const objectKeys = Object.keys(value);
        objectKeys.forEach(objectKey => {
          appendSafe(`${String(key)}.${objectKey}`, value[objectKey], true);
        });
      } else {
        appendSafe(String(key), value);
      }
    });
    return `?${params.toString()}`;
  }

  return '';
};

exports.getQueryParams = getQueryParams;

const appInfoToUserAgentString = appInfo => `(${appInfo.name || ''}; ${appInfo.version || ''}; ${appInfo.url || ''})`;

const buildUserAgentString = appInfo => {
  let userAgent = `${_constants.USER_AGENT_CLIENT}/${undefined || 'unknown'}`;

  if (appInfo && Object.keys(appInfo || {}).length) {
    userAgent += ` ${appInfoToUserAgentString(appInfo)}`;
  }

  return userAgent;
};

exports.buildUserAgentString = buildUserAgentString;

const getBrowser = () => {
  const {
    userAgent
  } = window.navigator;
  let version = 'unknown';

  const browser = _constants.BROWSER_LIST.find(b => userAgent.includes(b.browserUA));

  if (browser) {
    try {
      version = userAgent.split(`${browser.browserUA}/`)[1];
    } catch {
      version = 'unknown';
    }
  }

  return `${(browser === null || browser === void 0 ? void 0 : browser.browserName) || 'unknown'}/${version}`;
}; // the following product property is deprecated but it's the only way
// I've found to detect react-native


exports.getBrowser = getBrowser;

const isEnvReactNative = () => typeof window === 'object' && window.navigator.product === 'ReactNative';

const getOSVersion = () => {
  // react-native
  if (isEnvReactNative()) {
    return 'ReactNative';
  } // node


  if (typeof window === 'undefined') {
    try {
      return `${_os.default.type()}/${_os.default.version()}`;
    } catch {
      return 'unknown';
    }
  } // browser


  try {
    const appVersionString = window.navigator.appVersion;
    const osMatch = appVersionString.match(/\(([^)]+)\)/u);

    if (osMatch && osMatch.length > 1) {
      return osMatch[1];
    }

    return 'unknown';
  } catch {
    return 'unknown';
  }
};

exports.getOSVersion = getOSVersion;

const getRuntime = () => {
  // react-native
  if (isEnvReactNative()) {
    return 'ReactNative';
  } // node


  if (typeof window === 'undefined') {
    return `NodeJS/${process.version}`;
  } // browser


  return getBrowser();
};

exports.getRuntime = getRuntime;

const buildClientUserAgentString = appInfo => {
  const clientUserAgent = {
    client: _constants.USER_AGENT_CLIENT,
    clientVersion: undefined || 'unknown',
    osVersion: getOSVersion(),
    runtimeVersion: getRuntime(),
    application: {}
  };

  if (appInfo) {
    clientUserAgent.application = appInfo;
  }

  return JSON.stringify((0, _snakecaseKeys.default)(clientUserAgent));
};

exports.buildClientUserAgentString = buildClientUserAgentString;

const debugTransform = (data, headers) => {
  if (headers && typeof data === 'object' && data !== undefined) {
    // we are deliberately mutating the data object here to include the debug headers
    // eslint-disable-next-line no-param-reassign
    data._debug = { ...data._debug,
      cfRay: headers[_constants.CF_RAY_HEADER],
      btTraceId: headers[_constants.BT_TRACE_ID_HEADER]
    };
  }

  return data;
};

exports.debugTransform = debugTransform;